<template>
    <div class="text-center alert-light py-2">
        ------- 暫無資料 -------
    </div>
</template>

<script>
export default {
    name: 'NoData',
};
</script>
